import { combineReducers } from "redux";


import TopicArticlesReducer from './TopicArticlesReducer'
import TopicHistogramReducer from './TopicHistogramReducer'


export default combineReducers({
    Histogram: TopicHistogramReducer,
    Articles: TopicArticlesReducer
});

